import React from 'react';
import PropTypes from 'prop-types';
import { Textual } from './logo/textual';
import { Image } from './logo/image';

export const Logo = props =>
    props.hideManufacturerLogo
        ? <Textual manufacturer={props.manufacturer} />
        : <Image manufacturer={props.manufacturer} staticUrl="" manufacturerImage={props.manufacturerImage} />;

Logo.propTypes = {
    manufacturer: PropTypes.string.isRequired,
    hideManufacturerLogo: PropTypes.bool,
};

Logo.defaultProps = {
    hideManufacturerLogo: false,
};
